module.exports = __webpack_public_path__ + "496729defe0e00be530ecb43a8d1a4e9.fbx";